import {Injectable, signal} from '@angular/core';

export type MessagingPanelView = 'list' | 'chat' | 'new';

@Injectable({
  providedIn: 'root',
})
export class MessagingPanelService {
  private readonly panelOpen = signal(false);
  private readonly panelView = signal<MessagingPanelView>('list');
  private readonly activeInteractionId = signal<string | null>(null);

  public readonly isOpen = this.panelOpen.asReadonly();
  public readonly view = this.panelView.asReadonly();
  public readonly selectedInteractionId = this.activeInteractionId.asReadonly();

  /** Opens the panel on the interaction overview list. */
  public openList(): void {
    this.activeInteractionId.set(null);
    this.panelView.set('list');
    this.panelOpen.set(true);
  }

  /** Opens the panel directly on the chat of the given interaction. */
  public openChat(interactionId: string): void {
    this.activeInteractionId.set(interactionId);
    this.panelView.set('chat');
    this.panelOpen.set(true);
  }

  /** Opens the panel on the composer for a new interaction. */
  public openNewInteraction(): void {
    this.activeInteractionId.set(null);
    this.panelView.set('new');
    this.panelOpen.set(true);
  }

  /** Navigates back to the overview list while the panel stays open. */
  public showList(): void {
    this.activeInteractionId.set(null);
    this.panelView.set('list');
  }

  /** Switches the open panel to the chat of the given interaction. */
  public showChat(interactionId: string): void {
    this.activeInteractionId.set(interactionId);
    this.panelView.set('chat');
  }

  public close(): void {
    this.panelOpen.set(false);
  }
}
